<template lang='pug'>
  #app
    header: Logo
    main
      p Healthy Computer is a digital narrative design consultancy<br>based in New York
      p We optimize games, apps, and the design processes behind them for better social & behavioral outcomes
    footer
      a(href='https://anchor.fm/cognitiveload') Podcast
      Copyable(
        value='hey@healthy.computer'
        label-before='Copy our email'
        label-after='Copied!'
      )
</template>

<script>
import Logo from '@/components/Logo.vue'
import Copyable from '@/components/Copyable.vue'
import 'reset-css'

export default {
  name: 'app',
  components: {Logo, Copyable}
}
</script>

<style lang='stylus'>
@import url('//api.fontstore.com/webfonts/342fe097-36df-47d6-a346-924cfc6c8a89')

*
  box-sizing border-box

html, body, #app
  height 100%

#app
  font 20px/24px AssociateSans-Light, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  padding 0 20px
  display grid
  gap 32px
  grid-template:
    '.' 1fr\
    'head' max-content\
    'body' max-content\
    'foot' max-content\
    '.' 1fr\
    / 1fr
  @media (min-width 768px)
    padding 0
    display grid
    gap 32px
    grid-template:
      '. . . . .' 1fr\
      '. head . . .' max-content\
      '. . body . .' max-content\
      '. . . foot .' max-content\
      '. . . . .' 1fr\
      / 1fr max-content max-content max-content 1fr

header
  grid-area head
main
  grid-area body
  padding 24px 0
  @media (min-width 768px)
    padding 24px
footer
  grid-area foot
  margin-bottom 32px
  > *
    display block
    color inherit

p
  max-width 335px
  &+ &
    margin-top 20px
</style>
